import { motion } from "framer-motion";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { type LucideIcon } from "lucide-react";

export interface BannerButton {
  label: string;
  onClick: () => void;
  variant?: "default" | "destructive";
  className?: string;
}

export interface BannerConfig {
  alertClassName: string;
  Icon: LucideIcon;
  iconClassName: string;
  titleClassName: string;
  title: string;
  descriptionClassName: string;
  description: React.ReactNode;
  button?: BannerButton;
}

export default function BannerContent({
  alertClassName,
  Icon,
  iconClassName,
  titleClassName,
  title,
  descriptionClassName,
  description,
  button,
}: BannerConfig) {
  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.2, ease: "easeInOut" }}
      style={{ overflow: "hidden" }}
    >
      <div className="max-w-7xl mx-auto w-full px-6 py-2">
        <Alert className={alertClassName}>
          <Icon className={`h-4 w-4 ${iconClassName}`} />
          <AlertTitle className={titleClassName}>{title}</AlertTitle>
          <AlertDescription
            className={`${descriptionClassName} flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4`}
          >
            <p>{description}</p>
            {button && (
              <Button
                onClick={button.onClick}
                variant={button.variant ?? "default"}
                size="sm"
                className={`whitespace-nowrap ${button.className ?? ""}`.trim()}
              >
                {button.label}
              </Button>
            )}
          </AlertDescription>
        </Alert>
      </div>
    </motion.div>
  );
}
